import { Row, Card } from 'antd'

import DirtyStyle from '../../styles/DirtyLittleSecret.module.css'

const DirtyLittleSecret = () => {
  return (
    <div className={`${DirtyStyle["dirty-little-secret-screen"]}`}>
      <Row justify="center">
        <Card className={`${DirtyStyle["dirty-little-secret-card"]}`}>
          <article>
            <span>MONDAY, JULY 12, 2021 &nbsp;|&nbsp;NJLJ.COM</span>

            <hr />
            <h2 className={`${DirtyStyle["dirty-little-secret-above-title"]}`}>INSURANCE</h2>
            <hr />

            <h1 className={`${DirtyStyle["dirty-little-secret-title"]}`}>
              A Dirty Little Secret in Car Insurance: Can Lawyers Lead a Change?
            </h1>

            <p className={`${DirtyStyle["dirty-little-secret-author-name"]}`}>By Eric S. Poe</p>
            <hr />

            <figure className={`${DirtyStyle["right"]}`}>
              <img alt="person" src="https://assets.cure.com/img/main-site/eric_dirty_little_secret.png" />
              <figcaption>Eric S. Poe, Esq., CPA</figcaption>
            </figure>
            <p>
              You may be wondering why, amid intricate legal issues to discuss, is there an article on car insurance?
              Simple really— there’s a dirty little secret that needs to come to light. You probably know that to drive
              in New Jersey, you must carry car insurance. What you may not know is that even if you have a perfect
              driving record, New Jersey car insurance companies can charge you more if you don’t have a college
              education, if you work in a blue-collar job, if you rent your home, or if your credit score isn’t perfect.
            </p>
            <p>
              If that is not enough to alarm you, because car insurance in the state is mandatory, you can be fined and
              punished if you drive without it. In short, New Jersey drivers who don’t have a four-year college degree
              or who have lower credit scores are being charged more, forcing them to either overpay, or, if they cannot
              afford it, to forgo driving and hold jobs only accessible by foot, bicycle, or public transportation.
            </p>
            <p>
              Because these non-driving factors have such a clear connection to one’s salary, I have termed them “income
              proxies.” While there is no real evidence that these “income proxies” correlate to driver safety, they are
              linked to significant insurance industry profits. You see, wealthier drivers mean higher profits to my
              industry. Sadly, the blatantly obvious use of such proxies discriminates against those who make less money
              and those with less formal education—namely, minority families and lower income communities. These
              practices are clearly wrong.
            </p>
            <p>
              Being a car insurance CEO, I was appalled to learn about the widespread use of these income proxies in
              rate-setting, especially when considering the impact this has on minority and low-income drivers. I was
              embarrassed by my own industry, which led me to be the original “whistle blower” in 2004 against this
              hidden insider practice.
            </p>
            <p>
              While a great number of organizations and consumer advocates are in full support of ending these unfair
              pricing practices, many in the legal and professional communities are unaware of this injustice. I have
              been saying for years that this isn’t a Republican or Democrat issue; this is one of fundamental fairness.
              Even though this should not be political, the solution sits in the hands of our elected officials—and,
              disappointingly, there are some politicians who oppose a law to end this practice.
            </p>
            <p>
              The reason? One seems to be that there are not enough constituent complaints or voter outrage. So instead
              of correcting the clear and obvious inequity that the use of “income proxies” brings to the less
              fortunate—who don’t know they may be paying as much as 50% more because of their education level or
              occupation—these politicians are awaiting calls and letters from the public who are unaware that this
              secret practice is even Eric S. Poe, Esq., CPA INSURANCE Eric S. Poe, attorney and CPA, is principal and
              serves as chief executive officer and complex claims litigation officer for Citizens United Reciprocal
              Exchange (CURE) auto insurance, and New Jersey Physicians United Reciprocal Exchange (NJ PURE), a leading
              medical malpractice insurance carrier in the state. happening to them. One should ask, “How would people
              know to even lodge a complaint when individuals don’t know they are being rejected based on the absence of
              a four-year college degree, lack of a high paying white-collar job, or having a low credit score?” In
              short, it’s hard to complain about an issue that you don’t know exists.
            </p>
            <p>
              Let’s build awareness and give the politicians what they are looking for—complaints and outrage— so that
              they will end this hidden practice once and for all.
            </p>

            <h5>By Way of Background</h5>

            <figure className={`${DirtyStyle["left"]}`}>
              <img
                alt="insurancePolicy"
                className={`${DirtyStyle["dirty-little-secret-left-img"]}`}
                src="https://assets.cure.com/img/main-site/insurance_policy_dirty_little.png"
              />
            </figure>
            <p>
              Disgracefully, the use education and occupation been used as a proxy for race in the life insurance
              industry for years. Although race was banned as a factor for rate-setting with the passage of the Civil
              Rights Act of 1964, an examination by the National Association of Insurance Commissioners (NAIC) in the
              year 2000 uncovered that educational attainment and occupation had been used by several life insurance
              companies as proxies for race.
            </p>
            <p>
              Prior to the Civil Rights Act, when life insurance companies were permitted to consider race in
              underwriting, Black applicants were frequently rejected from an insurer’s preferred company that had
              better rates and greater benefits. As a result, these applicants would only be accepted in alternative
              affiliated life insurance companies with higher rates and fewer benefits. The same practice of re-routing
              minority applicants to affiliated companies with higher rates and lower benefits continued with the
              education/occupation proxy once race was removed from the application, highlighting the need for
              legislation and oversight in this arena.
            </p>

            <h5>Industry Practices Revealed</h5>

            <p>
              Like the life insurance companies, the car insurance industry uses income proxies because higher income
              applicants produce higher profits and more revenue streams. Simply put, these drivers have a greater
              amount of disposable income and provide the opportunity for insurers to sell insurance for multiple cars
              and other assets. The wealthy are also less likely to file a “minor” claim and tend to have fewer drivers,
              on average, per car. In lower income households, the opposite is true.
            </p>

            <p>
              <b>
                Even if you have a perfect driving record, NJ insurance companies can charge you more if you don’t have
                a college education or if you work in a blue-collar job.
              </b>
            </p>

            <p>
              Furthermore, unlike other industries, insurance companies can still make billions of dollars a year
              without insuring a majority of the market share. They would rather segment out the unprofitable risks
              entirely. As a result, insurance companies who want to capture only the most profitable risks can carve
              out the lower income drivers by employing what can be termed, “constructive rejection.”
            </p>

            <p>
              Think of “constructive discharge”—when employers make an employee’s work environment so arduous and
              uncomfortable, the employee is essentially forced to resign. It is the same in car insurance.
              “Constructive rejection” is when insurers charge such high rates to those drivers they don’t want to
              insure that the individuals are constructively rejected. Here, if unprofitable risks are the poor with
              less education and a lower paying job, they simply cannot afford the cost and ultimately do not buy the
              insurance. By employing this practice, the company is not technically “rejecting” the applicant, which
              would be illegal under the present statutes.
            </p>
            <p>
              How is this possible? Currently, some car insurers that use multicompany affiliates bearing the same
              trademark name are not required to disclose if a consumer is being rejected from their “preferred” company
              on the basis of their education and occupational status alone. Therefore, when an insurer gives its most
              preferential and lower rates to those with higher education levels Even if you have a perfect driving
              record, NJ insurance companies can charge you more if you don’t have a college education or if you work in
              a blue-collar job. PHOTO BY BIGSTOCK and better paying jobs, it does so without public outcry. Consumers
              simply don’t know why they are rejected.
            </p>

            <h5>The Opposition Is Loud</h5>

            <p>
              No company wants to be called out about hidden unfair practices, and as industry organizations such as the
              National Association of Insurance Commissioners (NAIC) and the National Council of Insurance Legislators
              (NCOIL) clamor to create special committees to address race and discrimination in insurance, many of the
              largest billion-dollar insurers are looking for any arguments that lend credence to a position that such
              rate setting policies are fair and just. From claims that include phrases like “actuarially sound” to
              questioning any correlation between occupation and rates, the opposition is endless. However, as easily as
              they manufacture these post-facto justifications, counterpoints are readily available to dispute them.
            </p>

            <p>
              Take the matter of actuarial or statistical justification for the use of such factors as education,
              occupation and credit score. While these factors have been shown to correlate to loss ratios, the issue
              should not be whether these factors are valid predictors of insurance company profitability. Rather, this
              is a matter of fairness. No government should force poorer people with fewer assets to purchase insurance
              at unfairly inflated rates and have no safeguards to ensure those rates are charged equitably.
            </p>

            <p>
              As for the correlation between occupation and rates, the practice ignores key data, and studies show this.
              Studies done by both Consumer Reports (“Effects of Varying Education Level and Job Status on Online Auto
              insurance Price Quotes,” January 2021) and Quality Planning Corporation (“More Drivers Are on the Roads,
              Who Are You Most Likely to Run Into? A Student? A Politician? A Librarian?” 2003) reinforce the unfair
              nature of using income proxies. InvestigateTV tested this theory on an insurer’s web site and found that
              yes, a doctor with a DUI was quoted less than a waitress with a high school diploma and spotless driving
              record. (DePompa, Rachel. “Rate Discrimination: Some insurance companies give better rates for customers
              with certain jobs, education”.)
            </p>

            <h5>The Road Ahead</h5>

            <p>
              The good news is New Jersey has the perfect opportunity to do the right thing. The state senate recently
              passed the Fair Auto Insurance Rates (FAIR) Act (S-111/A-1657), which would prohibit New Jersey car
              insurance companies from using residents’ education, occupation, marital status, home ownership status, or
              credit score in determining premiums. Having passed in the senate in January, it now awaits action in the
              Assembly Financial Institutions and Insurance Committee.
            </p>
            <p>
              New Jersey should join other states, such as New York and Michigan, and be a leader on this social justice
              issue, encouraging other states to follow suit. On a national level, legislation has been proposed in both
              in the House of Representatives and the Senate (HR-3693, S-4755). U.S. Representative and former New
              Jersey State Assemblywoman Bonnie Watson Coleman (D-NJ), alongside Representative Rashida Tlaib (D-MI),
              courageously stood up to corporate America and introduced the Prohibit Auto Insurance Discrimination Act
              (PAID Act) in July 2019. Senator Cory Booker (D-NJ) followed with the introduction of a companion bill in
              September 2020.
            </p>
            <p>
              Enough lip service—it’s time the legislature does what is fundamentally fair for all safe drivers in New
              Jersey. The time is now, during this election year, when each of us can make choices for the future. I
              urge us all to ask our individual legislators “What is your position?” and ask them to make what is an
              easy choice between what is right and wrong.
            </p>
            <p>
              This crusade has been a long one, and I may not have made many industry executive friends along the way. I
              was once told, &quot;Eric, you are talking ethics. This is business.&quot; My response: &quot;I
              didn&apos;t know they were mutually exclusive.&quot;
            </p>

            <hr />
            <p className={`${DirtyStyle["dirty-little-secret-author"]}`}>
              <span className={`${DirtyStyle["bold"]}`}>Eric S. Poe,</span> attorney and CPA, is principal and serves as chief executive
              officer and complex claims litigation officer for Citizens United Reciprocal Exchange (CURE) auto
              insurance, and New Jersey Physicians United Reciprocal Exchange (NJ PURE), a leading medical malpractice
              insurance carrier in the state.
            </p>

            <hr />
            <p className={`${DirtyStyle["dirty-little-secret-foot-note"]}`}>
              Reprinted with permission from the September 20, 2021 edition of the NEW JERSEY LAW JOURNAL.© 2021 ALM
              Media Properties, LLC. All rights reserved. Further duplication without permission is prohibited. For
              information, contact 877-256-2472, reprints@alm.com or visit{' '}
              <a
                className={`${DirtyStyle["dirty-little-secret-hyperlinks"]}`}
                href="https://almreprints.com/"
                rel="noreferrer"
                target="_blank"
              >
                www.almreprints.com
              </a>
              . NJLJ-09202021-520434
            </p>
          </article>
        </Card>
      </Row>
    </div>
  )
}

DirtyLittleSecret.propTypes = {}

export default DirtyLittleSecret
